import { createSelector } from '@ngrx/store';
import { CACHED_REQUEST_STATUS } from '../../classes/cached-request';
import { selectOfflineFeature } from './pace-offline-feature.selector';

export const selectRequestQueue = createSelector(selectOfflineFeature, (state) => state.requestQueue.requests);

export const pendingRequestCount = createSelector(selectRequestQueue, (requests) => requests.length);

export const isRequestPending = createSelector(pendingRequestCount, (requestCount) => requestCount > 0);

export const hasErroredPOSTRequest = createSelector(selectRequestQueue, (requests) => {
    return requests.some((request) => request.requestStatus === CACHED_REQUEST_STATUS.ERROR);
});

export const hasNonErroredPOSTRequest = createSelector(selectRequestQueue, (requests) => {
    return requests.some((request) => request.requestStatus !== CACHED_REQUEST_STATUS.ERROR);
});
